/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaSelectOneTitle/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaSelectOneTitle({
  children,
  viewPath = "/DesignSystem/TysiaSelectOne/TysiaSelectOneTitle",
  maxWidth = "calc(100% - 24px)",
  text,
  weight = "medium",
  size
  
}) {
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="TysiaSelectOneTitle.Horizontal"
  data-view-path={viewPath}
 style={{'--mw-1-Z1MaL2s': typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text={text}
 weight={weight}
 size={size}
 color={dtColorsNeutral500}
 paddingTop={dtSpaceXxs}
 paddingBottom={dtSpaceXxs}
 paddingLeft={dtSpaceXxs}
 paddingRight={dtSpaceXxs}
/>
</div>
{children}
</React.Fragment>)
}